import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ProgressBar = ({ progress }) => {
    const { themeStyles, theme } = useTheme();

    // Container style
    const containerStyle = {
        width: '100%',
        backgroundColor: theme === 'light' ? '#E0E0E0' : '#555555',
        borderRadius: '15px',
        border: `1px solid ${themeStyles.text}`,
        position: 'relative',
        height: '20px',
        overflow: 'hidden',
        boxShadow: theme === 'light' ? '0 4px 6px rgba(0, 0, 0, 0.1)' : '0 4px 6px rgba(0, 0, 0, 0.2)',
        cursor: 'pointer',
        transition: 'box-shadow 0.3s ease-in-out', // Smooth transition for hover effect
    };

    // Progress bar style with gradient effect
    const progressBarStyle = {
        width: `${progress}%`,
        height: '100%',
        background: `linear-gradient(90deg, ${themeStyles.primaryColor} ${progress}%)`, // Gradient effect
        borderRadius: '15px 0 0 15px',
        boxShadow: theme === 'light' ? '0 4px 6px rgba(0, 0, 0, 0.1)' : '0 4px 6px rgba(0, 0, 0, 0.2)',
        transition: 'width 0.3s ease-in-out',
    };

    // Text style for progress percentage below the bar
    const textStyle = {
        position: 'absolute',
        bottom: '-25px', // Position text below the progress bar
        left: '50%',
        transform: 'translateX(-50%)', // Center the text horizontally
        zIndex: 99,
        color: themeStyles.text,
        fontSize: '14px',
        fontWeight: '600',
        letterSpacing: '0.5px',
        transition: 'left 0.3s ease-in-out', // Smooth transition for text position
    };

    // Hover effect on container
    const handleMouseEnter = (e) => {
        e.target.style.boxShadow = theme === 'light'
            ? '0 4px 12px rgba(0, 0, 0, 0.2)'
            : '0 4px 12px rgba(0, 0, 0, 0.3)';
    };

    const handleMouseLeave = (e) => {
        e.target.style.boxShadow = theme === 'light'
            ? '0 4px 6px rgba(0, 0, 0, 0.1)'
            : '0 4px 6px rgba(0, 0, 0, 0.2)';
    };

    return (
        <div>
            <div
                style={containerStyle}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <div style={progressBarStyle}>
                    {/* The progress bar */}
                </div>
                {/* Text below the progress bar */}
            </div>
            <h1 style={{ marginBottom: 0, fontSize: 20, paddingTop: 10 }}>{Math.floor(Math.abs(progress))}% completed</h1>
        </div>

    );
};

export default ProgressBar;